import { GatsbySSR } from "gatsby"
import { globalStyles } from "@theme/globalStyles"

export const wrapRootElement: GatsbySSR["wrapRootElement"] = ({ element }) => {
  globalStyles()

  return element
}
